import script from "./LoaderPlug.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderPlug.vue?vue&type=script&setup=true&lang=js"

import "./LoaderPlug.vue?vue&type=style&index=0&id=fef826ae&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fef826ae"]])

export default __exports__